<template>
  <div>
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="mx-auto" outlined >
          <div class="v-lazy pa-5">
            <v-row>
              <v-col cols="6" class="text-h4">{{ $t("menu.news") }}</v-col>
              <v-col>
                <create class="float-end"></create>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <v-card-text>
              <v-data-table
                dense
                :headers="headers"
                :items="items"
                :items-per-page="-1"
                :hide-default-footer="true"
                item-key="id"
              >
            <template v-slot:item.NumRow="{ item,index }">
              {{ 1+index }}
            </template>
            <template v-slot:item.Cover="{ item }">
              <img :src="item.pathImg" style="max-height: 50px;">
            </template>
            <template v-slot:item.Action="{ item }">
              <edit :url="item.pathImg" :Topic="item.Topic" :Detail="item.Detail" :id="item.id"></edit>
              <v-btn icon color="red" @click="DeleteConfirm(item)" class="btn-card">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>

          </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="DeleteConfirmdialog" persistent max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          แน่ใจหรือว่าต้องการลบ?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="DeleteConfirmdialog = false">
            ยกเลิก
          </v-btn>
          <v-btn color="green darken-1" text @click="Delete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="DeleteCompletedialog" persistent max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          ลบข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="DeleteCompletedialog = false;GetData();">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import Create from "./create";
  import Edit from "./edit";
  export default {
    components: {
      Create,
      Edit
    },
    data() {
      return {
        items:[],
        snackbar:false,
        DeleteConfirmdialog:false,
        DeleteCompletedialog:false,
        itemDelete:null,
        headers: [
                  { text: 'ลำดับ', value: 'NumRow',sortable: false, align: 'start', },
                  { text: 'Cover', value: 'Cover',sortable: false, },
                  { text: 'หัวข้อ', value: 'Topic',sortable: false, },
                  { text: 'วันที่เขียน', value: 'created_at',sortable: false, },
                  { text: 'แก้ไขล่าสุด', value: 'updated_at',sortable: false, },
                  { text: '', value: 'Action',sortable: false, },
                ],
      };
    },

    methods: {
      GetData(){
        this.$store.commit('set_overlay',true);
         this.req.get(this.$store.getters.base_api + 'get-news/' + this.$store.getters.authen.locale).then(response=>{
          this.items = response.data.data.data;
          this.$store.commit('set_overlay',false);
        }).catch(error => {
          this.$store.commit('set_overlay',false);
        });
      },
      DeleteConfirm(item){
        this.DeleteConfirmdialog = true;
        this.itemDelete = item;
      },
      Delete(){
        this.$store.commit('set_overlay',true);
        this.DeleteConfirmdialog = false;
        let formData = new FormData();
            formData.append('id',this.itemDelete.id);
        this.req.post(this.$store.getters.base_api + 'delete-news',formData).then(response=>{
          this.DeleteCompletedialog = true;
        }).catch(error => {
          this.$store.commit('set_overlay',false);
        });
      },
  },
  mounted() {
    this.req = this.$store.getters.req;
    this.GetData();
  },



};
</script>
